import { appointmentsApi } from './appointments/appointments';
import { authApi } from './auth/auth';
import { bannersApi } from './banners/banners';
import { callsApi } from './calls/calls';
import { channelsApi } from './channels/channels';
import { documentsApi } from './documents/documents';
import { externalApi } from './external/external';
import { generalApi } from './general/general';
import { healthMetricsApi } from './healthMetrics/healthMetrics';
import { healthProfileApi } from './healthProfile/healthProfile';
import { homeProductsApi } from './homeProducts/homeProducts';
import { insuranceApi } from './insurance/insurance';
import { labRangesApi } from './labRanges/labRanges';
import { labTestsApi } from './labTests/labTests';
import { lookupApi } from './lookup/lookup';
import { marketoneApi } from './marketone/marketone';
import { medicareMigrationApi } from './medicareMigration/medicareMigration';
import { medicationsApi } from './medications/medications';
import { mifsApi } from './mifs/mifs';
import { myAccountApi } from './myAccount/myAccount';
import { notificationsApi } from './notifications/notifications';
import { ordersApi } from './orders/orders';
import { patientChartApi } from './patientChart/patientChart';
import { patientPortalInvoicesApi } from './patientPortalInvoices/patientPortalInvoices';
import { patientsApi } from './patients/patients';
import { pharmaciesApi } from './pharmacies/pharmacies';
import { programProductsApi } from './programProducts/programProducts';
import { programsApi } from './programs/programs';
import { providersApi } from './providers/providers';
import { reportsApi } from './reports/reports';
import { reviewApi } from './review/review';
import { schedulingApi } from './scheduling/scheduling';
import { settingsApi } from './settings/settings';
import { shopApi } from './shop/shop';
import { shopPageApi } from './shopPage/shopPage';
import { signupApi } from './signup/signup';
import { subscriptionsApi } from './subscriptions/subscriptions';
import { surveysApi } from './surveys/surveys';
import { wmApi } from './wm/wm';

export const apiServices = [
  appointmentsApi,
  authApi,
  bannersApi,
  callsApi,
  channelsApi,
  documentsApi,
  externalApi,
  generalApi,
  healthMetricsApi,
  healthProfileApi,
  homeProductsApi,
  insuranceApi,
  labRangesApi,
  labTestsApi,
  lookupApi,
  marketoneApi,
  medicareMigrationApi,
  medicationsApi,
  mifsApi,
  myAccountApi,
  notificationsApi,
  ordersApi,
  patientChartApi,
  patientPortalInvoicesApi,
  patientsApi,
  pharmaciesApi,
  programProductsApi,
  programsApi,
  providersApi,
  reportsApi,
  reviewApi,
  schedulingApi,
  settingsApi,
  shopApi,
  shopPageApi,
  signupApi,
  subscriptionsApi,
  surveysApi,
  wmApi
] as const;

export {
  appointmentsApi,
  authApi,
  bannersApi,
  callsApi,
  channelsApi,
  documentsApi,
  externalApi,
  generalApi,
  healthMetricsApi,
  healthProfileApi,
  homeProductsApi,
  insuranceApi,
  labRangesApi,
  labTestsApi,
  lookupApi,
  marketoneApi,
  medicareMigrationApi,
  medicationsApi,
  mifsApi,
  myAccountApi,
  notificationsApi,
  ordersApi,
  patientChartApi,
  patientPortalInvoicesApi,
  patientsApi,
  pharmaciesApi,
  programProductsApi,
  programsApi,
  providersApi,
  reportsApi,
  reviewApi,
  schedulingApi,
  settingsApi,
  shopApi,
  shopPageApi,
  signupApi,
  subscriptionsApi,
  surveysApi,
  wmApi
};
